import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

function ItemSubCategory() {

  const [data, setData] = useState([]);
  const [category, setCategory] = useState([]);
  const [mode, setMode] = useState("view");
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null); 
  const [form, setForm] = useState({
    CategoryID: "",
    SubCategoryName: "",
    Description: ""
  });
  useEffect(() => {
    loadData();
    loadCategory();
  }, []);
  const loadData = async () => {
    const res = await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "SC_V"
    });
    setData(res.data);
  };
  const loadCategory = async () => {
    const res = await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "CAT_V"
    });
    setCategory(res.data);
  };
  const handleSubmit = async (e) => {
  e.preventDefault();
  const subCategoryName = form.SubCategoryName.trim();
  const description = form.Description.trim();
  if (!form.CategoryID) {
    alert("Please select category");
    return;
  }
  if (!subCategoryName) {
    alert("Sub Category Name is required");
    return;
  }
  if (subCategoryName.length < 3) {
    alert("Sub Category Name must be at least 3 characters");
    return;
  }
  const nameRegex = /^[A-Za-z\s]+$/;

  if (!nameRegex.test(subCategoryName)) {
    alert("Only alphabets allowed");
    return;
  }
  const scriptRegex = /<script.*?>.*?<\/script>/gi;
  if (scriptRegex.test(subCategoryName)) {
    alert("Invalid Sub Category Name");
    return;
  }
  if (scriptRegex.test(description)) {
    alert("Invalid Description");
    return;
  }
  const duplicate = data.some(
    (d) =>
      d.ItemSubCategoryName.toLowerCase() === subCategoryName.toLowerCase() &&
      Number(d.ItemCategoryId) === Number(form.CategoryID) &&
      d.ItemSubCategoryId !== editId
  );
  if (duplicate) {
    alert("Sub Category already exists");
    return;
  }
  try {
    const action = editId ? "SC_U" : "SC_A";
    await axios.post(
      `${REACT_APP_API_URL}api/inventory/item`,
      {
        action,
        ItemSubCategoryId: editId || 0,
        ItemSubCategoryName: subCategoryName,
        ItemCategoryId: form.CategoryID,
        Description: description
      }
    );
    alert(editId ? "Updated Successfully" : "Added Successfully");
    resetForm();
    loadData();
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  }
};
  const handleEdit = (item) => {
    const id = item.ItemSubCategoryId;
    if (!id) {
      alert("Invalid ID");
      return;
    }
    setEditId(id);
    setForm({
      CategoryID: item.ItemCategoryId,
      SubCategoryName: item.ItemSubCategoryName,
      Description: item.Description
    });
    setShowModal(true);
  };
  const handleDelete = async (id) => {

    if (!id) {
      alert("Invalid ID");
      return;
    }
    if (!window.confirm("Delete this sub category?")) return;
    await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "SC_D",
      ItemSubCategoryIds: String(id)
    });

    alert("Deleted Successfully");
    loadData();
  };
  const resetForm = () => {
    setForm({
      CategoryID: "",
      SubCategoryName: "",
      Description: ""
    });
    setEditId(null);
    setShowModal(false);
  };
  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <div className="mb-3">
          <button
            className={`btn ${mode === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
            onClick={() => setMode("add")}
          >
            Add
          </button>
          <button
            className={`btn ${mode === "view" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setMode("view")}
          >
            View
          </button>
        </div>
        {mode === "add" && (
          <div className="text-center">
            <button className="btn btn-success" onClick={() => {
              resetForm();
              setShowModal(true);
            }}>
              + Add Sub Category
            </button>
          </div>
        )}
        {mode === "view" && (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Sl#</th>
                <th>Category</th>
                <th>Sub Category</th>
                <th>Description</th>
                <th>Action</th> 
              </tr>
            </thead>
            <tbody>
              {data.map((d, i) => (
                <tr key={d.ItemSubCategoryId}>
                  <td>{i + 1}</td>
                  <td>{d.ItemCategoryName}</td>
                  <td>{d.ItemSubCategoryName}</td>
                  <td>{d.Description}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleEdit(d)}
                    >
                      ✏️
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(d.ItemSubCategoryId)}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {showModal && (
        <>
          <div className="modal d-block">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5>{editId ? "Edit Sub Category" : "Add Sub Category"}</h5>
                  <button className="btn-close" onClick={resetForm}></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <select
                      className="form-control mb-2"
                      value={form.CategoryID}
                      onChange={(e) =>
                        setForm({ ...form, CategoryID: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Category</option>
                      {category.map(c => (
                        <option key={c.ItemCategoryId} value={c.ItemCategoryId}>
                          {c.ItemCategoryName}
                        </option>
                      ))}
                    </select>
                    <input
                      className="form-control mb-2"
                      placeholder="Sub Category Name"
                      maxLength={50}
                      value={form.SubCategoryName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          setForm({
                            ...form,
                            SubCategoryName: value
                          });
                        }
                      }}
                      required
                    />
                    <textarea
                      className="form-control mb-2"
                      placeholder="Description"
                      maxLength={200}
                      value={form.Description}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          setForm({
                            ...form,
                            Description: value
                          });
                        }
                      }}
                    />  
                    <button className="btn btn-success w-100">
                      {editId ? "Update" : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </>
      )}
    </div>
  );
}

export default ItemSubCategory;